import { TableStructure } from "../components/TableStructure";
import { SocialWelfareLeftMenuList } from "../utils/constants";

const List = [
  {
    fileStoreId: "18023926-2a59-4f3c-8a94-891f18042026",
    label: "Housing Urban Poor Form",
  },
  {
    fileStoreId: "18024026-2a59-4f3c-8a94-891f18042026",
    label: "Housing Urban Poor Site Plan",
  },
];

const Housing_Urban_Poor_Form_and_Site_Plan = () => (
  <TableStructure
    title="Housing Urban Poor Form and Site Plan:"
    heading={false}
    list={List}
    columnNo={1}
    leftMenuList={SocialWelfareLeftMenuList}
  />
);

export default Housing_Urban_Poor_Form_and_Site_Plan;
